import React from 'react'

import PropTypes from 'prop-types'

import { Container } from './styles'

const Tooltip = ({ title, className, children }) => {
  return (
    <Container className={className}>
      {children}
      <span className="message">
        {title}
      </span>
    </Container>
  )
}

Tooltip.propTypes = {
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
  children: PropTypes.element
}

export default Tooltip
